import React, { useState } from "react";
import "./Analysis.css"; // Import the corresponding CSS file
import { Link } from "react-router-dom";

function BeautifulPage() {
  const [result, setResult] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  function inference() {
    setIsLoading(true);
    setError(null);
    
    fetch(process.env.REACT_APP_API_URL + "/inferences", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Erreur lors de l'analyse");
        }
        return response.json();
      })
      .then((data) => {
        console.log("Response from server:", data);
        setResult(data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setError(error.message);
        setIsLoading(false);
      });
  }

  return (
    <div className="beautifulpage">
      {/* Navigation bar */}
      <div className="navbar">
        <ul className="nav_links">
          <li>
            <img src="/img/logo.png" alt="logo" className="nav-logo" />
          </li>
          <li>
            <Link to="/home">Accueil</Link>
          </li>
          <li>
            <Link to="/analysis" className="active">Analyse</Link>
          </li>
        </ul>
      </div>
      
      {/* Main content */}
      <div className="main-content">
        <h1 className="page-title">Analyse des Documents</h1>
        
        {/* Button */}
        <div className="button">
          <button 
            type="submit" 
            onClick={inference} 
            disabled={isLoading}
            className="analysis-button"
          >
            {isLoading ? "Analyse en cours..." : "Lancer l'analyse"}
          </button>
        </div>

        {error && (
          <div className="error-message">
            <p>{error}</p>
          </div>
        )}
        
        {isLoading && (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Analyse en cours, veuillez patienter...</p>
          </div>
        )}
        
        {/* Results section */}
        {result && !isLoading && (
          <div className="body">
            <h2 className="results-title">Résultats de l'analyse</h2>
            {result
              .reduce((acc, item) => {
                const documentIndex = item.DocumentIndex;
                const existingItem = acc.find(
                  (groupedItem) => groupedItem.documentIndex === documentIndex
                );

                if (existingItem) {
                  existingItem.results.push(item);
                } else {
                  acc.push({
                    documentIndex,
                    results: [item],
                  });
                }

                return acc;
              }, [])
              .map((group, groupIndex) => (
                <div key={groupIndex} className="result-box">
                  <h3 className="document-title">
                    Document {group.documentIndex + 1} {group.doc_name && `- ${group.doc_name}`}
                  </h3>
                  
                  <div className="scrollable-container">
                    {group.results.map((item, index) => (
                      <div key={index} className="result-item">
                        {item.Element && (
                          <>
                            <p className="analysis-text"><strong>Analyse:</strong> {item.Analysis}</p>
                            <p className="element-info">
                              <span className="info-label">Informations:</span> 
                              Ligne {item.Element.row}, 
                              Colonne {item.Element.column}, 
                              En-tàªte {item.Element.heading}
                            </p>
                          </>
                        )}
                        {!item.Element && <p className="analysis-text">{item.Analysis}</p>}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default BeautifulPage;
